import { validateWithSchema } from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import { commentSchema } from "@/schemas/comment";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { Comment } from "@/schemas/comment";

class CommentsService {
  async update(comment: Comment) {
    const url = formatString(endpoints.COMMENTS.SINGLE, comment.id);

    const { data } = await axiosClient<{ data: Comment }>({
      method: "PUT",
      url: url,
      data: comment,
    });

    return validateWithSchema(commentSchema, data.data);
  }

  async resolve(commentId: Comment["id"]) {
    const url = formatString(endpoints.COMMENTS.RESOLVE, commentId);

    const { data } = await axiosClient<{ data: Comment }>({
      method: "PUT",
      url: url,
    });

    return validateWithSchema(commentSchema, data.data);
  }

  async unresolve(commentId: Comment["id"]) {
    const url = formatString(endpoints.COMMENTS.UNRESOLVE, commentId);

    const { data } = await axiosClient<{ data: Comment }>({
      method: "PUT",
      url: url,
    });

    return validateWithSchema(commentSchema, data.data);
  }
}

const commentService = new CommentsService();
export default commentService;
